import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { untrack } from 'svelte';
import { addExpense, addFreeExpense, updateExpense, deleteExpense } from '$lib/api/splits';
import Button from '$lib/components/ui/button/button.svelte';
import Input from '$lib/components/ui/input/input.svelte';
import Label from '$lib/components/ui/label/label.svelte';
import * as Select from '$lib/components/ui/select';
import * as RadioGroup from '$lib/components/ui/radio-group';
import ConfirmDialog from '$lib/components/ui/confirm-dialog/confirm-dialog.svelte';
import { addToast } from '$lib/stores/toastStore.svelte';
import ShareEditModal from './ShareEditModal.svelte';
import { Moon, Edit3, Users, X, Info } from '$lib/icons';

var root_4 = $.from_html(`<p class="text-sm text-destructive"> </p>`);
var root_6 = $.from_html(`<p class="text-sm text-destructive"> </p>`);
var root_8 = $.from_html(`<!> <!>`, 1);
var root_15 = $.from_html(`<!> <span>By Night</span>`, 1);
var root_16 = $.from_html(`<!> <span>By Participant members</span>`, 1);
var root_17 = $.from_html(`<!> <span>Manual</span>`, 1);
var root_14 = $.from_html(`<div class="flex items-center space-x-2 p-3 border rounded-lg hover:bg-accent min-h-[44px]"><!> <!> <button type="button" class="p-1 rounded-full hover:bg-muted text-muted-foreground" aria-label="Info about By Night"><!></button></div> <div class="flex items-center space-x-2 p-3 border rounded-lg hover:bg-accent min-h-[44px]"><!> <!> <button type="button" class="p-1 rounded-full hover:bg-muted text-muted-foreground" aria-label="Info about By Participant members"><!></button></div> <div class="flex items-center space-x-2 p-3 border rounded-lg hover:bg-accent min-h-[44px]"><!> <!> <button type="button" class="p-1 rounded-full hover:bg-muted text-muted-foreground" aria-label="Info about Manual"><!></button></div>`, 1);
var root_21 = $.from_html(`<span> <!></span>`);
var root_20 = $.from_html(`<div class="text-sm text-muted-foreground"></div>`);
var root_23 = $.from_html(`<p class="text-sm text-muted-foreground">No participants selected</p>`);
var root_24 = $.from_html(`<p class="text-xs text-destructive">At least one participant must have positive parts</p>`);
var root_25 = $.from_html(`<!> Edit shares`, 1);
var root_18 = $.from_html(`<div class="space-y-2 p-4 border rounded-lg bg-muted/30"><div class="flex items-center justify-between"><!> <span> </span></div> <!> <!> <!></div>`);
var root_26 = $.from_html(`<div class="pt-2 border-t"><!></div>`);
var root_29 = $.from_svg(`<svg class="animate-spin h-4 w-4 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg> `, 1);
var root_34 = $.from_html(`<p class="text-sm text-muted-foreground leading-relaxed"> </p>`);
var root_32 = $.from_html(`<div class="fixed inset-0 z-[70] bg-black/50 flex items-end justify-center sm:items-center sm:p-4" role="dialog" aria-modal="true" aria-labelledby="split-info-modal-title" tabindex="-1"><div role="presentation" class="bg-background w-full sm:max-w-[420px] rounded-t-xl sm:rounded-xl shadow-lg animate-in fade-in slide-in-from-bottom-4 sm:zoom-in-95"><div class="flex items-center justify-between p-4 border-b"><h2 id="split-info-modal-title" class="text-base font-semibold"> </h2> <!></div> <div class="p-4 space-y-3"></div> <div class="p-4 border-t"><!></div></div></div>`);
var root_1 = $.from_html(`<div class="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4" role="dialog" aria-modal="true" aria-labelledby="expense-modal-title" tabindex="-1"><div role="presentation" class="bg-background rounded-lg shadow-lg w-full max-w-[420px] max-h-[calc(100vh-2rem)] flex flex-col animate-in fade-in zoom-in-95"><div class="flex items-center justify-between p-4 border-b"><h2 id="expense-modal-title" class="text-lg font-semibold"> </h2> <!></div> <form class="p-4 space-y-4 overflow-y-auto flex-1"><div class="space-y-2"><!> <!> <!></div> <div class="space-y-2"><!> <!> <!></div> <div class="space-y-2"><!> <!></div> <div class="space-y-2"><!> <!></div> <!> <!> <div class="flex gap-2 pt-2"><!> <!></div></form></div></div> <!>`, 1);
var root = $.from_html(`<!> <!> <!> <!>`, 1);

export default function ExpenseEditModal($$anchor, $$props) {
	$.push($$props, true);

	/**
	 * ExpenseEditModal - Unified modal for adding and editing expenses.
	 * Mode is determined by the `expense` prop: null = add, non-null = edit.
	 */
	// Props
	let expense = $.prop($$props, 'expense', 3, null),
		preselectedPayerId = $.prop($$props, 'preselectedPayerId', 3, null);

	// Derived mode
	const isEditMode = $.derived(() => expense() != null);

	// Form state
	let amount = $.state('');

	let description = $.state('');
	let payerId = $.state('');
	let payerSelected = $.state($.proxy({ value: '', label: '' }));
	let splitMode = $.state('BY_NIGHT');
	let shareParts = $.state($.proxy({}));
	let shareChecked = $.state($.proxy({}));
	let sharePreviousValues = $.state($.proxy({}));
	let isLoading = $.state(false);

	// Validation state
	let validationErrors = $.state($.proxy({}));

	let amountTouched = $.state(false);
	let descriptionTouched = $.state(false);

	// Split mode info modal state
	let activeInfo = $.state(null);

	const splitModeInfo = {
		BY_NIGHT: {
			title: 'By Night',
			description: `The cost is shared proportionally based on each participant's total "night-shares" — calculated as nights × share weight.\n\nThe share weight represents the number of persons. For example, a couple has a share of 2, while a solo traveller has a share of 1.\n\nExample: Alice (1 person) stays 3 nights = 3 night-shares. Bob & Carol (couple, 2 persons) stay 2 nights = 4 night-shares. Total = 7 night-shares.\n\nAlice pays 3/7 of the expense, Bob & Carol pay 4/7.`
		},

		BY_SHARE: {
			title: 'By Participant members',
			description: `The cost is split proportionally to each participant's share weight, which represents their number of persons.\n\nThis is ideal for shared expenses where everyone was present, like a restaurant meal.\n\nExample: Alice (1 person) and a couple Bob & Carol (2 persons) share a €90 restaurant bill. Total = 3 shares. Alice pays €30 (1/3), Bob & Carol pay €60 (2/3).`
		},

		FREE: {
			title: 'Manual',
			description: `You define the exact parts for each participant. You choose who is included and assign them a relative weight — the total cost is then distributed proportionally.\n\nExample: you assign Alice 1 part, Bob 2 parts, and Carol 3 parts. Total = 6 parts. Alice pays 1/6, Bob pays 2/6, Carol pays 3/6 of the expense.`
		}
	};

	function openInfo(mode, e) {
		e.preventDefault();
		e.stopPropagation();
		$.set(activeInfo, mode, true);
	}

	// Confirmation state
	let showDiscardConfirm = $.state(false);

	let showDeleteConfirm = $.state(false);
	let showShareEditModal = $.state(false);
	let isDeleting = $.state(false);

	// Dirty tracking (edit mode)
	const isSharesDirty = $.derived(() => expense() != null && expense().splitMode === 'FREE' && $$props.participants.some((p) => {
		const currentVal = typeof $.get(shareParts)[p.id] === 'number'
			? $.get(shareParts)[p.id]
			: parseFloat(String($.get(shareParts)[p.id])) || 0;

		const originalShare = expense().shares?.find((s) => s.participantId === p.id);
		const originalVal = originalShare?.parts ?? 0;

		return currentVal !== originalVal;
	}));

	const isDirtyEdit = $.derived(() => expense() != null && ((typeof $.get(amount) === 'number' ? $.get(amount) : parseFloat($.get(amount)) || 0) !== expense().amount || $.get(description) !== expense().description || $.get(payerId) !== expense().payerId || $.get(splitMode) !== expense().splitMode || $.get(isSharesDirty)));

	// Dirty tracking (add mode)
	const isDirtyAdd = $.derived(() => $.get(amount) !== '' || $.get(description) !== '' || $.get(payerId) !== '' && $.get(payerId) !== preselectedPayerId() || $.get(splitMode) !== 'BY_NIGHT' || Object.entries($.get(shareParts)).some(([id, val]) => {
		if (id === $.get(payerId)) return val !== 1;

		return val !== '' && val !== 0;
	}));

	const isDirty = $.derived(() => $.get(isEditMode) ? $.get(isDirtyEdit) : $.get(isDirtyAdd));

	// Derived validation
	const amountValue = $.derived(() => typeof $.get(amount) === 'number' ? $.get(amount) : parseFloat($.get(amount)) || 0);

	const isAmountValid = $.derived(() => $.get(amountValue) >= 0.01 && $.get(amountValue) <= 999999.99);
	const isDescriptionValid = $.derived(() => $.get(description).trim().length > 0 && $.get(description).length <= 200);
	const isPayerValid = $.derived(() => $.get(payerId) !== '');

	// FREE mode parts validation
	const totalParts = $.derived(() => Object.values($.get(shareParts)).reduce(
		(sum, val) => {
			const numVal = typeof val === 'number' ? val : parseFloat(String(val)) || 0;

			return sum + numVal;
		},
		0
	));

	const isPartsValid = $.derived(() => $.get(splitMode) !== 'FREE' || $.get(totalParts) > 0);
	const isValid = $.derived(() => $.get(isAmountValid) && $.get(isDescriptionValid) && $.get(isPayerValid) && $.get(isPartsValid));

	// In add mode: only disable during loading (validation errors shown on submit)
	// In edit mode: disable when not dirty, invalid, or loading/deleting
	const canSubmit = $.derived(() => $.get(isEditMode)
		? $.get(isDirtyEdit) && $.get(isValid) && !$.get(isLoading) && !$.get(isDeleting)
		: !$.get(isLoading));

	// Initialize form when modal opens
	$.user_effect(() => {
		if ($$props.open) {
			untrack(() => resetForm());

			setTimeout(
				() => {
					if (typeof document !== 'undefined') {
						document.getElementById('expense-description-modal')?.focus();
					}
				},
				50
			);
		}
	});

	function resetForm() {
		$.set(validationErrors, {}, true);
		$.set(amountTouched, false);
		$.set(descriptionTouched, false);
		$.set(showDiscardConfirm, false);
		$.set(showDeleteConfirm, false);
		$.set(isLoading, false);
		$.set(isDeleting, false);

		// Initialize share parts, checkboxes, and previous values for all participants
		$.set(shareParts, {}, true);

		$.set(shareChecked, {}, true);
		$.set(sharePreviousValues, {}, true);

		for (const participant of $$props.participants) {
			$.get(shareParts)[participant.id] = '';
			$.get(shareChecked)[participant.id] = false;
			$.get(sharePreviousValues)[participant.id] = 1;
		}

		if (expense()) {
			// Edit mode: populate from expense
			$.set(amount, expense().amount, true);

			$.set(description, expense().description, true);
			$.set(payerId, expense().payerId, true);
			$.set(splitMode, expense().splitMode, true);

			const payer = $$props.participants.find((p) => p.id === expense().payerId);

			if (payer) {
				$.set(payerSelected, { value: payer.id, label: payer.name }, true);
			}

			// Populate share data from existing expense shares (FREE mode)
			if (expense().splitMode === 'FREE' && expense().shares) {
				for (const share of expense().shares) {
					const parts = share.parts ?? 0;

					if (parts > 0) {
						$.get(shareChecked)[share.participantId] = true;
						$.get(shareParts)[share.participantId] = parts;
						$.get(sharePreviousValues)[share.participantId] = parts;
					}
				}
			}
		} else {
			// Add mode: blank form with optional pre-selected payer
			$.set(amount, '');

			$.set(description, '');
			$.set(splitMode, 'BY_NIGHT');

			if (preselectedPayerId()) {
				const participant = $$props.participants.find((p) => p.id === preselectedPayerId());

				if (participant) {
					$.set(payerId, participant.id, true);
					$.set(payerSelected, { value: participant.id, label: participant.name }, true);
				}
			} else if ($$props.participants.length > 0) {
				$.set(payerId, $$props.participants[0].id, true);

				$.set(
					payerSelected,
					{
						value: $$props.participants[0].id,
						label: $$props.participants[0].name
					},
					true
				);
			}

			// Default: payer checked with value 1
			if ($.get(payerId)) {
				$.get(shareChecked)[$.get(payerId)] = true;
				$.get(shareParts)[$.get(payerId)] = 1;
			}
		}
	}

	function validateAmount() {
		if ($.get(amount) === '' || $.get(amountValue) < 0.01) {
			$.get(validationErrors).amount = 'Amount must be at least €0.01';
		} else if ($.get(amountValue) > 999999.99) {
			$.get(validationErrors).amount = 'Amount cannot exceed €999,999.99';
		} else {
			delete $.get(validationErrors).amount;
			$.set(validationErrors, { ...$.get(validationErrors) }, true);
		}
	}

	function validateDescription() {
		if ($.get(description).trim().length === 0) {
			$.get(validationErrors).description = 'Description is required';
		} else if ($.get(description).length > 200) {
			$.get(validationErrors).description = 'Description cannot exceed 200 characters';
		} else {
			delete $.get(validationErrors).description;
			$.set(validationErrors, { ...$.get(validationErrors) }, true);
		}
	}

	function handleAmountKeydown(event) {
		if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
			event.preventDefault();

			const current = typeof $.get(amount) === 'number' ? $.get(amount) : parseFloat($.get(amount)) || 0;
			const next = event.key === 'ArrowUp' ? current + 0.5 : Math.max(0, current - 0.5);

			$.set(amount, Math.round(next * 100) / 100);
		}
	}

	function handleAmountBlur() {
		$.set(amountTouched, true);
		validateAmount();
	}

	function handleDescriptionBlur() {
		$.set(descriptionTouched, true);
		validateDescription();
	}

	// Shares summary: list of checked participants with their parts
	const checkedShares = $.derived(() => $$props.participants.filter((p) => $.get(shareChecked)[p.id]).map((p) => {
		const val = typeof $.get(shareParts)[p.id] === 'number'
			? $.get(shareParts)[p.id]
			: parseFloat(String($.get(shareParts)[p.id])) || 0;

		return { name: p.name, parts: val };
	}));

	function handleShareEditConfirm(data) {
		$.set(shareParts, data.shareParts, true);
		$.set(shareChecked, data.shareChecked, true);
		$.set(sharePreviousValues, data.sharePreviousValues, true);
		$.set(showShareEditModal, false);
	}

	async function handleSubmit() {
		$.set(amountTouched, true);
		$.set(descriptionTouched, true);
		validateAmount();
		validateDescription();

		if (!$.get(canSubmit)) return;

		$.set(isLoading, true);

		try {
			if ($.get(splitMode) === 'FREE') {
				const shares = $$props.participants.map((p) => ({
					participantId: p.id,

					parts: typeof $.get(shareParts)[p.id] === 'number'
						? $.get(shareParts)[p.id]
						: parseFloat($.get(shareParts)[p.id]) || 0
				}));

				if ($.get(isEditMode) && expense()) {
					// FREE mode update: delete old + create new (backend doesn't support updating shares)
					await deleteExpense($$props.splitId, expense().id);
				}

				await addFreeExpense($$props.splitId, {
					amount: $.get(amountValue),
					description: $.get(description).trim(),
					payerId: $.get(payerId),
					shares
				});

				addToast({
					type: 'success',
					message: $.get(isEditMode) ? 'Expense updated' : 'Expense added',
					description: `${$.get(description).trim()} · €${$.get(amountValue).toFixed(2)} · Paid by ${$$props.participants.find((p) => p.id === $.get(payerId))?.name ?? 'Unknown'}`
				});
			} else if ($.get(isEditMode) && expense()) {
				await updateExpense($$props.splitId, expense().id, {
					amount: $.get(amountValue),
					description: $.get(description).trim(),
					payerId: $.get(payerId),
					splitMode: $.get(splitMode)
				});

				addToast({
					type: 'success',
					message: 'Expense updated',
					description: `${$.get(description).trim()} · €${$.get(amountValue).toFixed(2)} · Paid by ${$$props.participants.find((p) => p.id === $.get(payerId))?.name ?? 'Unknown'}`
				});
			} else {
				await addExpense($$props.splitId, {
					amount: $.get(amountValue),
					description: $.get(description).trim(),
					payerId: $.get(payerId),
					splitMode: $.get(splitMode)
				});

				addToast({
					type: 'success',
					message: 'Expense added',
					description: `${$.get(description).trim()} · €${$.get(amountValue).toFixed(2)} · Paid by ${$$props.participants.find((p) => p.id === $.get(payerId))?.name ?? 'Unknown'}`
				});
			}

			await $$props.onSuccess();
			$$props.onClose();
		} catch(err) {
			const error = err;

			addToast({
				type: 'error',

				message: error.detail || ($.get(isEditMode)
					? 'Failed to update expense. Please try again.'
					: 'Failed to add expense. Please try again.')
			});
		} finally {
			$.set(isLoading, false);
		}
	}

	function handleCloseAttempt() {
		if ($.get(isDirty)) {
			$.set(showDiscardConfirm, true);
		} else {
			$$props.onClose();
		}
	}

	function handleConfirmDiscard() {
		$.set(showDiscardConfirm, false);
		$$props.onClose();
	}

	function handleCancelDiscard() {
		$.set(showDiscardConfirm, false);
	}

	function handleDeleteClick() {
		$.set(showDeleteConfirm, true);
	}

	async function handleConfirmDelete() {
		if (!expense()) return;

		$.set(isDeleting, true);

		try {
			await deleteExpense($$props.splitId, expense().id);

			addToast({
				type: 'success',
				message: 'Expense deleted',
				description: `${expense().description} · €${expense().amount.toFixed(2)}`
			});

			$.set(showDeleteConfirm, false);
			await $$props.onSuccess();
			$$props.onClose();
		} catch(err) {
			const error = err;

			addToast({
				type: 'error',
				message: error.detail || 'Failed to delete expense'
			});
		} finally {
			$.set(isDeleting, false);
		}
	}

	function handleCancelDelete() {
		$.set(showDeleteConfirm, false);
	}

	function handleKeydown(event) {
		if (!$$props.open) return;

		if (event.key === 'Escape' && !$.get(isLoading) && !$.get(showDiscardConfirm) && !$.get(showDeleteConfirm) && !$.get(showShareEditModal)) {
			handleCloseAttempt();
		}

		// Focus trap - keep Tab within modal (WCAG 2.1)
		if (event.key === 'Tab') {
			const modal = document.querySelector('[role="dialog"]');

			if (!modal) return;

			const focusable = modal.querySelectorAll('button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])');

			if (focusable.length === 0) return;

			const first = focusable[0];
			const last = focusable[focusable.length - 1];

			if (event.shiftKey && document.activeElement === first) {
				event.preventDefault();
				last.focus();
			} else if (!event.shiftKey && document.activeElement === last) {
				event.preventDefault();
				first.focus();
			}
		}
	}

	function handleBackdropClick(event) {
		if (event.target === event.currentTarget && !$.get(isLoading) && !$.get(isDeleting)) {
			handleCloseAttempt();
		}
	}

	var fragment = root();

	$.event('keydown', $.window, handleKeydown);

	var node = $.first_child(fragment);

	{
		var consequent_9 = ($$anchor) => {
			var fragment_1 = root_1();
			var div = $.first_child(fragment_1);

			div.__click = handleBackdropClick;

			var div_1 = $.child(div);

			div_1.__click = (e) => e.stopPropagation();

			var div_2 = $.child(div_1);
			var h2 = $.child(div_2);
			var text = $.child(h2, true);

			$.reset(h2);

			var node_1 = $.sibling(h2, 2);

			{
				let $0 = $.derived(() => $.get(isLoading) || $.get(isDeleting));

				Button(node_1, {
					variant: 'ghost',
					size: 'sm',
					onclick: handleCloseAttempt,

					get disabled() {
						return $.get($0);
					},

					class: 'min-h-[44px] min-w-[44px]',
					'aria-label': 'Close',

					children: ($$anchor, $$slotProps) => {
						X($$anchor, { class: 'h-4 w-4' });
					},

					$$slots: { default: true }
				});
			}

			$.reset(div_2);

			var form = $.sibling(div_2, 2);
			var div_3 = $.child(form);
			var node_2 = $.child(div_3);

			Label(node_2, {
				for: 'expense-description-modal',

				children: ($$anchor, $$slotProps) => {
					$.next();

					var text_1 = $.text('Description');

					$.append($$anchor, text_1);
				},

				$$slots: { default: true }
			});

			var node_3 = $.sibling(node_2, 2);

			{
				let $0 = $.derived(() => $.get(descriptionTouched) && !!$.get(validationErrors).description);
				let $1 = $.derived(() => $.get(isLoading) || $.get(isDeleting));

				Input(node_3, {
					id: 'expense-description-modal',
					type: 'text',
					placeholder: 'e.g., Groceries',
					onblur: handleDescriptionBlur,
					class: 'min-h-[44px]',

					get 'aria-invalid'() {
						return $.get($0);
					},

					get disabled() {
						return $.get($1);
					},

					get value() {
						return $.get(description);
					},

					set value($$value) {
						$.set(description, $$value, true);
					}
				});
			}

			var node_4 = $.sibling(node_3, 2);

			{
				var consequent = ($$anchor) => {
					var p_1 = root_4();
					var text_2 = $.child(p_1, true);

					$.reset(p_1);
					$.template_effect(() => $.set_text(text_2, $.get(validationErrors).description));
					$.append($$anchor, p_1);
				};

				$.if(node_4, ($$render) => {
					if ($.get(descriptionTouched) && $.get(validationErrors).description) $$render(consequent);
				});
			}

			$.reset(div_3);

			var div_4 = $.sibling(div_3, 2);
			var node_5 = $.child(div_4);

			Label(node_5, {
				for: 'expense-amount-modal',

				children: ($$anchor, $$slotProps) => {
					$.next();

					var text_3 = $.text('Amount (€)');

					$.append($$anchor, text_3);
				},

				$$slots: { default: true }
			});

			var node_6 = $.sibling(node_5, 2);

			{
				let $0 = $.derived(() => $.get(amountTouched) && !!$.get(validationErrors).amount);
				let $1 = $.derived(() => $.get(isLoading) || $.get(isDeleting));

				Input(node_6, {
					id: 'expense-amount-modal',
					type: 'number',
					step: 'any',
					placeholder: '€0.00',
					onkeydown: handleAmountKeydown,
					onblur: handleAmountBlur,
					class: 'min-h-[44px]',

					get 'aria-invalid'() {
						return $.get($0);
					},

					get disabled() {
						return $.get($1);
					},

					get value() {
						return $.get(amount);
					},

					set value($$value) {
						$.set(amount, $$value, true);
					}
				});
			}

			var node_7 = $.sibling(node_6, 2);

			{
				var consequent_1 = ($$anchor) => {
					var p_2 = root_6();
					var text_4 = $.child(p_2, true);

					$.reset(p_2);
					$.template_effect(() => $.set_text(text_4, $.get(validationErrors).amount));
					$.append($$anchor, p_2);
				};

				$.if(node_7, ($$render) => {
					if ($.get(amountTouched) && $.get(validationErrors).amount) $$render(consequent_1);
				});
			}

			$.reset(div_4);

			var div_5 = $.sibling(div_4, 2);
			var node_8 = $.child(div_5);

			Label(node_8, {
				for: 'expense-payer-modal',

				children: ($$anchor, $$slotProps) => {
					$.next();

					var text_5 = $.text('Payer');

					$.append($$anchor, text_5);
				},

				$$slots: { default: true }
			});

			var node_9 = $.sibling(node_8, 2);

			$.component(node_9, () => Select.Root, ($$anchor, Select_Root) => {
				Select_Root($$anchor, {
					onSelectedChange: (selected) => {
						if (selected) {
							$.set(payerId, selected.value, true);
							$.set(payerSelected, selected, true);
						}
					},

					get selected() {
						return $.get(payerSelected);
					},

					set selected($$value) {
						$.set(payerSelected, $$value, true);
					},

					children: ($$anchor, $$slotProps) => {
						var fragment_3 = root_8();
						var node_10 = $.first_child(fragment_3);

						{
							let $0 = $.derived(() => $.get(isLoading) || $.get(isDeleting));

							$.component(node_10, () => Select.Trigger, ($$anchor, Select_Trigger) => {
								Select_Trigger($$anchor, {
									id: 'expense-payer-modal',
									class: 'min-h-[44px]',

									get disabled() {
										return $.get($0);
									},

									children: ($$anchor, $$slotProps) => {
										var fragment_4 = $.comment();
										var node_11 = $.first_child(fragment_4);

										$.component(node_11, () => Select.Value, ($$anchor, Select_Value) => {
											Select_Value($$anchor, { placeholder: 'Select payer' });
										});

										$.append($$anchor, fragment_4);
									},

									$$slots: { default: true }
								});
							});
						}

						var node_12 = $.sibling(node_10, 2);

						$.component(node_12, () => Select.Content, ($$anchor, Select_Content) => {
							Select_Content($$anchor, {
								children: ($$anchor, $$slotProps) => {
									var fragment_5 = $.comment();
									var node_13 = $.first_child(fragment_5);

									$.each(node_13, 17, () => $$props.participants, $.index, ($$anchor, participant) => {
										var fragment_6 = $.comment();
										var node_14 = $.first_child(fragment_6);

										$.component(node_14, () => Select.Item, ($$anchor, Select_Item) => {
											Select_Item($$anchor, {
												get value() {
													return $.get(participant).id;
												},

												get label() {
													return $.get(participant).name;
												},

												children: ($$anchor, $$slotProps) => {
													$.next();

													var text_6 = $.text();

													$.template_effect(() => $.set_text(text_6, $.get(participant).name));
													$.append($$anchor, text_6);
												},

												$$slots: { default: true }
											});
										});

										$.append($$anchor, fragment_6);
									});

									$.append($$anchor, fragment_5);
								},

								$$slots: { default: true }
							});
						});

						$.append($$anchor, fragment_3);
					},

					$$slots: { default: true }
				});
			});

			$.reset(div_5);

			var div_6 = $.sibling(div_5, 2);
			var node_15 = $.child(div_6);

			Label(node_15, {
				children: ($$anchor, $$slotProps) => {
					$.next();

					var text_7 = $.text('Split Mode');

					$.append($$anchor, text_7);
				},

				$$slots: { default: true }
			});

			var node_16 = $.sibling(node_15, 2);

			{
				let $0 = $.derived(() => $.get(isLoading) || $.get(isDeleting));

				$.component(node_16, () => RadioGroup.Root, ($$anchor, RadioGroup_Root) => {
					RadioGroup_Root($$anchor, {
						class: 'flex flex-col space-y-2',

						get disabled() {
							return $.get($0);
						},

						get value() {
							return $.get(splitMode);
						},

						set value($$value) {
							$.set(splitMode, $$value, true);
						},

						children: ($$anchor, $$slotProps) => {
							var fragment_8 = root_14();
							var div_7 = $.first_child(fragment_8);
							var node_17 = $.child(div_7);

							$.component(node_17, () => RadioGroup.Item, ($$anchor, RadioGroup_Item) => {
								RadioGroup_Item($$anchor, { value: 'BY_NIGHT', id: 'modal-mode-by-night' });
							});

							var node_18 = $.sibling(node_17, 2);

							Label(node_18, {
								for: 'modal-mode-by-night',
								class: 'flex items-center gap-2 cursor-pointer flex-1',

								children: ($$anchor, $$slotProps) => {
									var fragment_9 = root_15();
									var node_19 = $.first_child(fragment_9);

									Moon(node_19, { class: 'h-4 w-4', 'aria-hidden': 'true' });
									$.next(2);
									$.append($$anchor, fragment_9);
								},

								$$slots: { default: true }
							});

							var button = $.sibling(node_18, 2);

							button.__click = (e) => openInfo('BY_NIGHT', e);

							var node_20 = $.child(button);

							Info(node_20, { class: 'h-4 w-4' });
							$.reset(button);
							$.reset(div_7);

							var div_8 = $.sibling(div_7, 2);
							var node_21 = $.child(div_8);

							$.component(node_21, () => RadioGroup.Item, ($$anchor, RadioGroup_Item_1) => {
								RadioGroup_Item_1($$anchor, { value: 'BY_SHARE', id: 'modal-mode-by-share' });
							});

							var node_22 = $.sibling(node_21, 2);

							Label(node_22, {
								for: 'modal-mode-by-share',
								class: 'flex items-center gap-2 cursor-pointer flex-1',

								children: ($$anchor, $$slotProps) => {
									var fragment_10 = root_16();
									var node_23 = $.first_child(fragment_10);

									Users(node_23, { class: 'h-4 w-4', 'aria-hidden': 'true' });
									$.next(2);
									$.append($$anchor, fragment_10);
								},

								$$slots: { default: true }
							});

							var button_1 = $.sibling(node_22, 2);

							button_1.__click = (e) => openInfo('BY_SHARE', e);

							var node_24 = $.child(button_1);

							Info(node_24, { class: 'h-4 w-4' });
							$.reset(button_1);
							$.reset(div_8);

							var div_9 = $.sibling(div_8, 2);
							var node_25 = $.child(div_9);

							$.component(node_25, () => RadioGroup.Item, ($$anchor, RadioGroup_Item_2) => {
								RadioGroup_Item_2($$anchor, { value: 'FREE', id: 'modal-mode-free' });
							});

							var node_26 = $.sibling(node_25, 2);

							Label(node_26, {
								for: 'modal-mode-free',
								class: 'flex items-center gap-2 cursor-pointer flex-1',

								children: ($$anchor, $$slotProps) => {
									var fragment_11 = root_17();
									var node_27 = $.first_child(fragment_11);

									Edit3(node_27, { class: 'h-4 w-4', 'aria-hidden': 'true' });
									$.next(2);
									$.append($$anchor, fragment_11);
								},

								$$slots: { default: true }
							});

							var button_2 = $.sibling(node_26, 2);

							button_2.__click = (e) => openInfo('FREE', e);

							var node_28 = $.child(button_2);

							Info(node_28, { class: 'h-4 w-4' });
							$.reset(button_2);
							$.reset(div_9);
							$.append($$anchor, fragment_8);
						},

						$$slots: { default: true }
					});
				});
			}

			$.reset(div_6);

			var node_29 = $.sibling(div_6, 2);

			{
				var consequent_5 = ($$anchor) => {
					var div_10 = root_18();
					var div_11 = $.child(div_10);
					var node_30 = $.child(div_11);

					Label(node_30, {
						class: 'text-sm font-medium',

						children: ($$anchor, $$slotProps) => {
							$.next();

							var text_8 = $.text('Share Parts');

							$.append($$anchor, text_8);
						},

						$$slots: { default: true }
					});

					var span = $.sibling(node_30, 2);
					var text_9 = $.child(span);

					$.reset(span);
					$.reset(div_11);

					var node_31 = $.sibling(div_11, 2);

					{
						var consequent_3 = ($$anchor) => {
							var div_12 = root_20();

							$.each(div_12, 21, () => $.get(checkedShares), $.index, ($$anchor, share, i) => {
								var span_1 = root_21();
								var text_10 = $.child(span_1);
								var node_32 = $.sibling(text_10);

								{
									var consequent_2 = ($$anchor) => {
										var text_11 = $.text(',');

										$.append($$anchor, text_11);
									};

									$.if(node_32, ($$render) => {
										if (i < $.get(checkedShares).length - 1) $$render(consequent_2);
									});
								}

								$.reset(span_1);
								$.template_effect(() => $.set_text(text_10, `${$.get(share).name ?? ''}: ${$.get(share).parts ?? ''}`));
								$.append($$anchor, span_1);
							});

							$.reset(div_12);
							$.append($$anchor, div_12);
						};

						var alternate = ($$anchor) => {
							var p_3 = root_23();

							$.append($$anchor, p_3);
						};

						$.if(node_31, ($$render) => {
							if ($.get(checkedShares).length > 0) $$render(consequent_3); else $$render(alternate, false);
						});
					}

					var node_33 = $.sibling(node_31, 2);

					{
						var consequent_4 = ($$anchor) => {
							var p_4 = root_24();

							$.append($$anchor, p_4);
						};

						$.if(node_33, ($$render) => {
							if (!$.get(isPartsValid) && ($.get(amountTouched) || $.get(descriptionTouched))) $$render(consequent_4);
						});
					}

					var node_34 = $.sibling(node_33, 2);

					{
						let $0 = $.derived(() => $.get(isLoading) || $.get(isDeleting));

						Button(node_34, {
							type: 'button',
							variant: 'outline',
							size: 'sm',

							onclick: () => {
								$.set(showShareEditModal, true);
							},

							get disabled() {
								return $.get($0);
							},

							class: 'w-full min-h-[44px]',

							children: ($$anchor, $$slotProps) => {
								var fragment_12 = root_25();
								var node_35 = $.first_child(fragment_12);

								Edit3(node_35, { class: 'h-4 w-4 mr-2' });
								$.next();
								$.append($$anchor, fragment_12);
							},

							$$slots: { default: true }
						});
					}

					$.reset(div_10);

					$.template_effect(
						($0) => {
							$.set_class(span, 1, `text-sm ${$.get(isPartsValid) ? 'text-green-600' : 'text-destructive'}`);
							$.set_text(text_9, `${$0 ?? ''} parts ${$.get(totalParts) > 0 ? '✓' : '⚠'}`);
						},
						[() => $.get(totalParts).toFixed(2)]
					);

					$.append($$anchor, div_10);
				};

				$.if(node_29, ($$render) => {
					if ($.get(splitMode) === 'FREE') $$render(consequent_5);
				});
			}

			var node_36 = $.sibling(node_29, 2);

			{
				var consequent_6 = ($$anchor) => {
					var div_13 = root_26();
					var node_37 = $.child(div_13);

					{
						let $0 = $.derived(() => $.get(isLoading) || $.get(isDeleting));

						Button(node_37, {
							type: 'button',
							variant: 'destructive',
							onclick: handleDeleteClick,

							get disabled() {
								return $.get($0);
							},

							class: 'w-full min-h-[44px]',
							'aria-label': 'Delete expense',

							children: ($$anchor, $$slotProps) => {
								$.next();

								var text_12 = $.text('Delete Expense');

								$.append($$anchor, text_12);
							},

							$$slots: { default: true }
						});
					}

					$.reset(div_13);
					$.append($$anchor, div_13);
				};

				$.if(node_36, ($$render) => {
					if ($.get(isEditMode)) $$render(consequent_6);
				});
			}

			var div_14 = $.sibling(node_36, 2);
			var node_38 = $.child(div_14);

			{
				let $0 = $.derived(() => !$.get(canSubmit));

				Button(node_38, {
					type: 'submit',

					get disabled() {
						return $.get($0);
					},

					class: 'flex-1 min-h-[44px]',

					children: ($$anchor, $$slotProps) => {
						var fragment_13 = $.comment();
						var node_39 = $.first_child(fragment_13);

						{
							var consequent_7 = ($$anchor) => {
								var fragment_14 = root_29();
								var text_13 = $.sibling($.first_child(fragment_14), 1, true);

								$.template_effect(() => $.set_text(text_13, $.get(isEditMode) ? 'Saving...' : 'Adding...'));
								$.append($$anchor, fragment_14);
							};

							var alternate_1 = ($$anchor) => {
								var text_14 = $.text();

								$.template_effect(() => $.set_text(text_14, $.get(isEditMode) ? 'Save Changes' : 'Add Expense'));
								$.append($$anchor, text_14);
							};

							$.if(node_39, ($$render) => {
								if ($.get(isLoading)) $$render(consequent_7); else $$render(alternate_1, false);
							});
						}

						$.append($$anchor, fragment_13);
					},

					$$slots: { default: true }
				});
			}

			var node_40 = $.sibling(node_38, 2);

			{
				let $0 = $.derived(() => $.get(isLoading) || $.get(isDeleting));

				Button(node_40, {
					type: 'button',
					variant: 'outline',
					onclick: handleCloseAttempt,

					get disabled() {
						return $.get($0);
					},

					class: 'flex-1 min-h-[44px]',

					children: ($$anchor, $$slotProps) => {
						$.next();

						var text_15 = $.text('Cancel');

						$.append($$anchor, text_15);
					},

					$$slots: { default: true }
				});
			}

			$.reset(div_14);
			$.reset(form);
			$.reset(div_1);
			$.reset(div);

			var node_41 = $.sibling(div, 2);

			{
				var consequent_8 = ($$anchor) => {
					var div_15 = root_32();

					div_15.__click = () => {
						$.set(activeInfo, null);
					};

					var div_16 = $.child(div_15);

					div_16.__click = (e) => e.stopPropagation();

					var div_17 = $.child(div_16);
					var h2_1 = $.child(div_17);
					var text_16 = $.child(h2_1, true);

					$.reset(h2_1);

					var node_42 = $.sibling(h2_1, 2);

					Button(node_42, {
						variant: 'ghost',
						size: 'sm',

						onclick: () => {
							$.set(activeInfo, null);
						},

						class: 'min-h-[44px] min-w-[44px]',
						'aria-label': 'Close',

						children: ($$anchor, $$slotProps) => {
							X($$anchor, { class: 'h-4 w-4' });
						},

						$$slots: { default: true }
					});

					$.reset(div_17);

					var div_18 = $.sibling(div_17, 2);

					$.each(div_18, 21, () => splitModeInfo[$.get(activeInfo)].description.split('\n\n'), $.index, ($$anchor, paragraph) => {
						var p_5 = root_34();
						var text_17 = $.child(p_5, true);

						$.reset(p_5);
						$.template_effect(() => $.set_text(text_17, $.get(paragraph)));
						$.append($$anchor, p_5);
					});

					$.reset(div_18);

					var div_19 = $.sibling(div_18, 2);
					var node_43 = $.child(div_19);

					Button(node_43, {
						onclick: () => {
							$.set(activeInfo, null);
						},

						class: 'w-full min-h-[44px]',

						children: ($$anchor, $$slotProps) => {
							$.next();

							var text_18 = $.text('Got it');

							$.append($$anchor, text_18);
						},

						$$slots: { default: true }
					});

					$.reset(div_19);
					$.reset(div_16);
					$.reset(div_15);
					$.template_effect(() => $.set_text(text_16, splitModeInfo[$.get(activeInfo)].title));
					$.append($$anchor, div_15);
				};

				$.if(node_41, ($$render) => {
					if ($.get(activeInfo)) $$render(consequent_8);
				});
			}

			$.template_effect(() => $.set_text(text, $.get(isEditMode) ? 'Edit Expense' : 'Add Expense'));

			$.event('submit', form, (e) => {
				e.preventDefault();
				handleSubmit();
			});

			$.append($$anchor, fragment_1);
		};

		$.if(node, ($$render) => {
			if ($$props.open) $$render(consequent_9);
		});
	}

	var node_44 = $.sibling(node, 2);

	ConfirmDialog(node_44, {
		get open() {
			return $.get(showDiscardConfirm);
		},

		title: 'Discard changes?',
		description: 'You have unsaved changes. Are you sure you want to close?',
		confirmLabel: 'Discard',
		cancelLabel: 'Keep editing',
		onConfirm: handleConfirmDiscard,
		onCancel: handleCancelDiscard
	});

	var node_45 = $.sibling(node_44, 2);

	ConfirmDialog(node_45, {
		get open() {
			return $.get(showDeleteConfirm);
		},

		title: 'Delete this expense?',
		description: 'This will recalculate balances.',
		confirmLabel: 'Delete',
		cancelLabel: 'Cancel',

		get isLoading() {
			return $.get(isDeleting);
		},

		onConfirm: handleConfirmDelete,
		onCancel: handleCancelDelete
	});

	var node_46 = $.sibling(node_45, 2);

	{
		let $0 = $.derived(() => ({
			shareParts: $.get(shareParts),
			shareChecked: $.get(shareChecked),
			sharePreviousValues: $.get(sharePreviousValues)
		}));

		ShareEditModal(node_46, {
			get open() {
				return $.get(showShareEditModal);
			},

			get participants() {
				return $$props.participants;
			},

			get initialData() {
				return $.get($0);
			},

			onConfirm: handleShareEditConfirm,

			onCancel: () => {
				$.set(showShareEditModal, false);
			}
		});
	}

	$.append($$anchor, fragment);
	$.pop();
}

$.delegate(['click']);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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